import React, { useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styles from "./Navbar.module.scss";
import { FaUserCircle, FaSignOutAlt, FaCog } from "react-icons/fa";
import { useAuth } from "../../../hooks/useAuth";
import { useCategories } from "../../../hooks/useCategories";
import toast from "react-hot-toast";
import { HttpError } from "../../../lib/http/HttpClient";
import { hasAnyRole } from "../../../routes/guards/RequireRole";
import { Role } from "../../../assets/js/roles.js";
import SearchEventsInput from "../../SearchEventsInput/SearchEventsInput";
import { GiCheckedShield } from "react-icons/gi";
import image from "../../../assets/images/Vaslolo-completo.svg";

const Navbar = ({ withSearch = false, events = [] }) => {
  const navigate = useNavigate();
  const { user, loading, logout } = useAuth();
  const { categories, loading: loadingCats } = useCategories();
  const isAuth = !!user;

  const isAdmin = useMemo(
    () => hasAnyRole(user?.data?.roles, [Role?.ADMIN]),
    [user],
  );
  const isAdminClubes = useMemo(
    () => hasAnyRole(user?.data?.roles, [Role?.CLUB_ADMIN]),
    [user],
  );

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (error) {
      if (error instanceof HttpError) {
        toast.error(error.body.description);
      } else {
        toast.error("Ha ocurrido un error");
      }
    }
  };

  const handleSelectEvent = (item) => {
    navigate(`/eventos/${item.event_id}`);
  };

  return (
    <nav className={`container ${styles.navbar}`}>
      <div className="d-flex align-items-center gap-4">
        <NavLink
          to="/"
          className={styles.logo}
        >
          <img
            className="mb-3"
            width={100}
            src={image}
            alt=""
          />
        </NavLink>

        <ul className={styles.navLinks}>
          <li>
            <NavLink
              to="/todos"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Todos
            </NavLink>
          </li>

          {loadingCats ? (
            <li>Cargando...</li>
          ) : (
            categories.map((cat) => (
              <li key={cat.id}>
                <NavLink
                  to={`/${cat.slug}`}
                  state={{ title: cat.name }}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                >
                  {cat.name}
                </NavLink>
              </li>
            ))
          )}

          <li key='contacto'>
            <NavLink
              to="/contacto"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Contacto
            </NavLink>
          </li>
          <li key='abonos'>
            <NavLink
              to={`/abonos`}
              state={{ title: "abonos" }}
              className={({ isActive }) =>
                isActive ? styles.activeAbonoNavlink : styles.abonoNavlink
              }
            >
              Abonos
            </NavLink>
          </li>
        </ul>
      </div>

      <div className={styles.inputNavbar}>
        {withSearch && (
          <SearchEventsInput
            events={events}
            onSelect={handleSelectEvent}
          />
        )}
      </div>

      <div className={styles.actions}>
        {!loading && isAuth && (
          <>
            {isAdmin && (
              <NavLink
                to="/backoffice"
                className={styles.adminBtn}
              >
                <FaCog size={14} />
                <span>Admin</span>
              </NavLink>
            )}

            {isAdminClubes && (
              <NavLink
                to="/backoffice-clubes"
                className={styles.adminBtn}
              >
                <GiCheckedShield size={14} />
                <span>Admin Clubes</span>
              </NavLink>
            )}

            <NavLink
              to="/usuario"
              className={styles.iconBtn}
            >
              <span className={styles.tooltip}>Perfil</span>
              <FaUserCircle size={18} />
            </NavLink>

            <button
              onClick={handleLogout}
              className={styles.iconBtn}
            >
              <span className={styles.tooltip}>Salir</span>
              <FaSignOutAlt size={16} />
            </button>
          </>
        )}

        {!loading && !isAuth && (
          <>
            <ul className={styles.navLinks}>
              <li>
                <NavLink to="/login">
                  <p>Iniciar sesión</p>
                </NavLink>
              </li>
            </ul>

            <NavLink
              to="/login"
              className={styles.iconBtnIniciarSesion}
            >
              <span className={styles.tooltip}>Iniciar sesión</span>
              <FaUserCircle size={18} />
            </NavLink>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;









